import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const TubeIcon = ({ className = '', width = 22,  height = 20 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 22 20'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M10.7995 0C15.4012 0 19.2467 3.23779 20.1822 7.55949L21.5995 7.56009V11.714L20.1659 11.7142C19.203 15.999 15.375 19.2001 10.7997 19.2001C6.22445 19.2001 2.39631 15.9989 1.43357 11.7142L0 11.714V7.56009L1.41732 7.55949C2.35286 3.23789 6.19796 0 10.7995 0ZM16.4166 11.7144H5.18251C6.03771 13.9849 8.22986 15.6003 10.7995 15.6003C13.3692 15.6003 15.5613 13.9849 16.4166 11.7144ZM10.7995 3.6C8.20239 3.6 5.99076 5.25014 5.15576 7.55918H16.4433C15.6082 5.25014 13.3966 3.6 10.7995 3.6Z'
                fill={color}
                fillRule='evenodd'/>
        </svg>


    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default TubeIcon;
